import { render, staticRenderFns } from "./RemoveImageModal.vue?vue&type=template&id=062f359f&"
import script from "./RemoveImageModal.vue?vue&type=script&lang=ts&"
export * from "./RemoveImageModal.vue?vue&type=script&lang=ts&"
import style0 from "./RemoveImageModal.vue?vue&type=style&index=0&id=062f359f&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports